<div class="pfp-modal-overlay" (click)="stage === 'gateway' ? close() : null">
  <div class="pfp-modal" (click)="$event.stopPropagation()">

    <ng-container *ngIf="stage === 'gateway' || stage === 'submitting'">
      <div class="pfp-modal-head">
        <h3 class="pfp-modal-title">{{ 'payNow' | translate }}</h3>
        <button type="button" class="pfp-modal-close" (click)="close()"><i class="ri-close-line"></i></button>
      </div>

      <div class="pfp-modal-body">
        <div class="pfp-selected-fees" *ngIf="cards.length > 1">
          <div class="pfp-selected-fee-row" *ngFor="let c of cards">
            <span>{{ c.name }}</span>
            <span>&#8377;{{ (c.balance + (c.lateFee > 0 ? c.lateFee : 0)) | number }}</span>
          </div>
        </div>
        <div class="pfp-amount-row">
          <span>{{ paymentDescription }}</span>
          <strong>&#8377;{{ totalAmount | number }}</strong>
        </div>

        <div class="pfp-gateway-loading" *ngIf="gatewaysLoading"><i class="ri-loader-4-line pfp-spin"></i></div>
        <div class="pfp-gateway-error" *ngIf="gatewaysError">{{ gatewaysError }}</div>

        <ng-container *ngIf="!gatewaysLoading && gateways.length > 1">
          <label class="pfp-field-label">{{ 'selectPaymentGateway' | translate }}</label>
          <div class="pfp-gateway-list">
            <label class="pfp-gateway-option" *ngFor="let gw of gateways" [class.selected]="selectedGatewayId === gw.pkPaymentGatewayId">
              <input type="radio" name="gateway" [value]="gw.pkPaymentGatewayId" [(ngModel)]="selectedGatewayId" />
              <img *ngIf="gw.paymentGatewayLogo" [src]="gw.paymentGatewayLogo" alt="" />
              <span>{{ gw.paymentGatewayName }}</span>
            </label>
          </div>
        </ng-container>

        <label class="pfp-field-label">{{ 'emailAddress' | translate }}</label>
        <input type="email" class="pfp-input" [(ngModel)]="email" [disabled]="submitting" placeholder="you&#64;example.com" />

        <div class="pfp-error-message" *ngIf="submitError">{{ submitError }}</div>

        <div class="pfp-blocked-message" *ngIf="blockedTimeLabel">
          <i class="ri-time-line"></i>
          {{ 'tryAgainIn' | translate }} {{ blockedTimeLabel }}
        </div>
      </div>

      <div class="pfp-modal-actions">
        <button type="button" class="pfp-btn-secondary" (click)="close()" [disabled]="submitting">{{ 'cancel' | translate }}</button>
        <button type="button" class="pfp-btn-primary" (click)="submitPayment()" [disabled]="submitting || gatewaysLoading || !gateways.length || !!blockedTimeLabel">
          {{ (submitting ? 'pleaseWait' : 'payNow') | translate }}
        </button>
      </div>
    </ng-container>

    <div class="pfp-status-body" *ngIf="stage === 'razorpay'">
      <i class="ri-loader-4-line pfp-spin pfp-status-icon"></i>
      <div class="pfp-status-text">{{ 'processingPayment' | translate }}</div>
    </div>

    <div class="pfp-status-body" *ngIf="stage === 'instamojo'">
      <i class="ri-external-link-line pfp-status-icon"></i>
      <div class="pfp-status-text">{{ 'openedInNewTab' | translate }}</div>
      <p class="pfp-status-subtext">{{ 'instamojoConfirmPrompt' | translate }}</p>
      <div class="pfp-instamojo-actions">
        <button type="button" class="pfp-btn-secondary" (click)="close()">{{ 'cancel' | translate }}</button>
        <button type="button" class="pfp-btn-primary" (click)="confirmInstamojoDone()">{{ 'paymentCompleted' | translate }}</button>
      </div>
    </div>

    <div class="pfp-status-body" *ngIf="stage === 'polling'">
      <i class="ri-loader-4-line pfp-spin pfp-status-icon"></i>
      <div class="pfp-status-text">{{ 'processingPayment' | translate }}</div>
      <p class="pfp-status-subtext">{{ 'openedInNewTab' | translate }}</p>
      <button type="button" class="pfp-btn-secondary" (click)="cancelPolling()">{{ 'cancel' | translate }}</button>
    </div>

    <div class="pfp-status-body" *ngIf="stage === 'success'">
      <i class="ri-checkbox-circle-fill pfp-status-icon pfp-status-icon-success"></i>
      <div class="pfp-status-text">{{ 'paymentSuccessful' | translate }}</div>
      <div class="pfp-status-amount">&#8377;{{ totalAmount | number }}</div>
      <div class="pfp-status-subtext">{{ paymentDescription }}<span *ngIf="studentName"> &middot; {{ studentName }}</span></div>
      <div class="pfp-status-subtext" *ngIf="successReferenceId">{{ 'referenceId' | translate }}: {{ successReferenceId }}</div>
      <button type="button" class="pfp-btn-primary" (click)="close()">{{ 'close' | translate }}</button>
    </div>

    <div class="pfp-status-body" *ngIf="stage === 'failed'">
      <i class="ri-close-circle-fill pfp-status-icon pfp-status-icon-failed"></i>
      <div class="pfp-status-text">{{ 'paymentFailed' | translate }}</div>
      <div class="pfp-status-amount">&#8377;{{ totalAmount | number }}</div>
      <div class="pfp-status-subtext">{{ paymentDescription }}<span *ngIf="studentName"> &middot; {{ studentName }}</span></div>
      <p class="pfp-status-subtext" *ngIf="failedReason">{{ failedReason }}</p>
      <button type="button" class="pfp-btn-primary" (click)="close()">{{ 'close' | translate }}</button>
    </div>

  </div>
</div>
